import { defineStore } from 'pinia';
import {
  RegulatoryUpdateCustomerInfo,
  RegulatoryUpdateCustomerAddress,
  RegulatoryUpdateCustomerPersonalProfile,
  RegulatoryUpdateCustomerInvestmentProfile,
  RegulatoryUpdateCustomerUsPerson,
  RegulatoryUpdateCustomerTaxResidence
} from '../types';

const initialState: RegulatoryUpdateCustomerInfo = {
  personalProfile: {
    mobile: '',
    fullName: '',
    cpf: '',
    sex: '',
    birthDate: '',
    birthCity: '',
    birthState: '',
    nationality: '',
    motherName: '',
    maritalStatus: '',
    partnerName: '',
    partnerCpf: '',
    partnerForeignRne: '',
    education: '',
    profession: '',
    professionId: '',
    hasProfession: false,
    workOrganization: '',
    workOrganizationCnpj: '',
    isExposed: false
  },
  address: {
    zipcode: '',
    street: '',
    neighborhood: '',
    number: '',
    city: '',
    state: '',
    complement: ''
  },
  investmentProfile: {
    monthlyIncome: 0,
    totalInvested: 0,
    movableProperty: 0,
    realEstate: 0,
    privatePension: 0,
    isProfessionalInvestor: false,
    isQualifiedInvestor: false
  }
};

export const useRegulatoryUpdateStore = defineStore('regulatoryUpdate', {
  state: (): RegulatoryUpdateCustomerInfo => initialState,

  actions: {
    setPersonalProfile(
      profile: Partial<RegulatoryUpdateCustomerPersonalProfile> | null
    ) {
      this.personalProfile = {
        ...this.personalProfile,
        ...profile
      } as RegulatoryUpdateCustomerPersonalProfile;
    },

    updatePersonalProfileField(
      field: keyof RegulatoryUpdateCustomerPersonalProfile,
      value: string | boolean | null
    ) {
      if (this.personalProfile) {
        (this.personalProfile as any)[field] = value;
      } else {
        this.personalProfile = {
          [field]: value
        } as unknown as RegulatoryUpdateCustomerPersonalProfile;
      }
    },

    setAddress(address: Partial<RegulatoryUpdateCustomerAddress> | null) {
      this.address = {
        ...this.address,
        ...address
      } as RegulatoryUpdateCustomerAddress;
    },

    updateAddressField(
      field: keyof RegulatoryUpdateCustomerAddress,
      value: string
    ) {
      if (this.address) {
        this.address[field] = value;
      } else {
        this.address = {
          [field]: value
        } as unknown as RegulatoryUpdateCustomerAddress;
      }
    },

    setInvestmentProfile(
      profile: Partial<RegulatoryUpdateCustomerInvestmentProfile> | null
    ) {
      this.investmentProfile = {
        ...this.investmentProfile,
        ...profile
      } as RegulatoryUpdateCustomerInvestmentProfile;
    },

    setUsPerson(usPerson: Partial<RegulatoryUpdateCustomerUsPerson> | null) {
      this.usPerson = {
        ...this.usPerson,
        ...usPerson
      } as RegulatoryUpdateCustomerUsPerson;
    },

    setTaxResidence(
      taxResidence: Partial<RegulatoryUpdateCustomerTaxResidence> | null
    ) {
      this.taxResidence = {
        ...this.taxResidence,
        ...taxResidence
      } as RegulatoryUpdateCustomerTaxResidence;
    }
  }
});
